import { HttpClient, HttpParams } from '@angular/common/http';
import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, Equipment, EquipmentInspectionForcastingViewModel, UnsyncedEquipmentInfoViewModel, ApplicationSelectedItem, UcPlannerDetail, UcFleetEquipmentDetail, UcFleet, UCPlannerComponent, UcActionRecommedSearch, UcPlannerTrackQuoteDetailVm, UcPlannerDataVM, ActionQuoteCheck, EquipmentQuoteSummaryVm, UcPlannerStatusUpdate, PmServiceTypesVM, UcPlannerGrapVm, UcPlannerGrapHeadingsVm, QuoteDetailResultVm, DisplayOptionDate, MonthlyQuoteSummaryVM, ResponseM } from './setup-equipment.model';
import { Model, Tuple } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { ComponentTypeVM, JobsiteTypeVM, filterComponentPerformance, CmponentSearchResult, ComponentActionHistroyVM } from '../manage-components/manage-components.model';
import { GenericIdName } from '../GET_NEW_UI/setup-implement/setup-implement.model';


@Injectable()
export class SetupEquipmentService {
    private readonly API_BASE = 'api/setupequipment/';
    private readonly GET_CUSTOMER_LIST = this.API_BASE + 'GetCustomerList';
    private readonly GET_JOBSITE_LIST = this.API_BASE + 'GetJobsiteList';
    private readonly GET_EQUIPMENT_LIST = this.API_BASE + 'GetEquipmentList';
    private readonly GET_MAKES = this.API_BASE + 'GetMakeList';
    private readonly GET_OEM_MAKES = this.API_BASE + 'GetOEMMakeList';
    private readonly GET_MODELS = this.API_BASE + 'GetModelList';
    private readonly GET_FAMILY_NAME_FOR_MODEL = this.API_BASE + 'GetFamilyNameForModel';
    private readonly GET_EQUIPMENT_RANKING_LIST = this.API_BASE + 'GetEquipmentRankingListAsync';
    private readonly GET_APPLICATION_LIST = this.API_BASE + 'GetEquipmentApplicationListAsync';
    private readonly VALIDATE_SERIAL_UNIT_NUMBER = this.API_BASE + 'ValidateSerialAndUnitNumberAsync';
    private readonly CREATE_NEW_EQUIPMENT = this.API_BASE + 'CreateNewEquipment';
    private readonly GET_EQUIPMENT_SETUP_DETAILS = this.API_BASE + 'GetEquipmentSetupDetails';
    private readonly UPDATE_EQUIPMENT = this.API_BASE + 'UpdateEquipmentAsync';
    private readonly UPDATE_INSPECTION_PLANNER = this.API_BASE + 'UpdateEquipmentInspectionPlanner';
    private readonly UPDATE_INSPECTION_FORECAST = this.API_BASE + 'UpdateEquipmentInspectionForcast';
    private readonly GET_UNSYNCED_EQUIPMENTINFO = this.API_BASE + 'GetUnsyncedEquipmentInfomation';
    private readonly GET_USEREMAIL = this.API_BASE + 'GetUserEmail';
    private readonly SEND_NEW_MODEL_EMAIL = this.API_BASE + 'RequestANewModel';
    private readonly VALIDATE_SERIAL_UNIT_NUMBER_DEALERGROUP = this.API_BASE + 'ValidateSerialAndUnitNumberDealerGroupAsync';
    private readonly GET_OEM_MAKES_BY_FAMILY = this.API_BASE + 'GetOEMMakeListByTypeId';
    private readonly GET_MODELS_BY_MAKE_FAMILY = this.API_BASE + 'GetModelListByfamilyandMake';
    private readonly GET_QUESTION_TYPES = this.API_BASE + 'GetQuestionTypes';
    private readonly SEND_NEW_CHAIN_EMAIL = this.API_BASE + 'RequestANewChain';

    constructor(private _http: HttpClient) { }

    public getEquipmentSetupDetails(equipmentId: number): Observable<Equipment> {
        let options = {
            params: new HttpParams().set('equipmentId', equipmentId.toString())
        };
        return this._http.get<Equipment>(this.GET_EQUIPMENT_SETUP_DETAILS, options).pipe(catchError(this.handleError));
    }

    public updateEquipment(equipment: Equipment): Observable<Tuple> {
        return this._http.post<Tuple>(this.UPDATE_EQUIPMENT, equipment).pipe(catchError(this.handleError));
    }

    public updateInspectionPlanner(equipment: Equipment): Observable<Tuple> {
        return this._http.post<Tuple>(this.UPDATE_INSPECTION_PLANNER, equipment).pipe(catchError(this.handleError));
    }


    public updateInspectionForecast(model: EquipmentInspectionForcastingViewModel): Observable<Tuple> {
        return this._http.post<Tuple>(this.UPDATE_INSPECTION_FORECAST, model).pipe(catchError(this.handleError));
    }


    public createNewEquipment(equipment: Equipment): Observable<Tuple> {
        return this._http.post<Tuple>(this.CREATE_NEW_EQUIPMENT, equipment).pipe(catchError(this.handleError));
    }

    public getCustomerList(): Observable<CustomerSelectItem[]> {
        return this._http.get<CustomerSelectItem[]>(this.GET_CUSTOMER_LIST).pipe(catchError(this.handleError));
    }

    public getQuestionTypes(): Observable<GenericIdName[]> {
        return this._http.get<GenericIdName[]>(this.GET_QUESTION_TYPES).pipe(catchError(this.handleError));
    }


    public getJobsiteList(customerId: number): Observable<JobsiteSelectItem[]> {
        let options = {
            params: new HttpParams().set('customerId', customerId.toString())
        };
        return this._http.get<JobsiteSelectItem[]>(this.GET_JOBSITE_LIST, options).pipe(catchError(this.handleError));
    }

    public getEquipmentList(jobsiteId: number): Observable<EquipmentSelectItem[]> {
        let options = {
            params: new HttpParams().set('jobsiteId', jobsiteId.toString())
        };
        return this._http.get<EquipmentSelectItem[]>(this.GET_EQUIPMENT_LIST, options).pipe(catchError(this.handleError));
    }
    public getOEMMakeListByFamilyId(FamilyId: number): Observable<CustomerSelectItem[]> {
        let options = {
            params: new HttpParams().set('FamilyId', FamilyId.toString())
        };
        return this._http.get<CustomerSelectItem[]>(this.GET_OEM_MAKES_BY_FAMILY, options).pipe(catchError(this.handleError));
    }

    public getMakeList(): Observable<CustomerSelectItem[]> {
        return this._http.get<CustomerSelectItem[]>(this.GET_MAKES).pipe(catchError(this.handleError));
    }
    public getOEMMakeList(): Observable<CustomerSelectItem[]> {
        return this._http.get<CustomerSelectItem[]>(this.GET_OEM_MAKES).pipe(catchError(this.handleError));
    }
    public getModelList(makeId: number): Observable<JobsiteSelectItem[]> {
        let options = {
            params: new HttpParams().set('makeId', makeId.toString())
        };
        return this._http.get<JobsiteSelectItem[]>(this.GET_MODELS, options).pipe(catchError(this.handleError));
    }
    public GetModelListByfamilyandMake(makeId: number, familyId: number): Observable<JobsiteSelectItem[]> {
        let options = {
            params: new HttpParams().set('makeId', makeId.toString()).set('familyId', familyId.toString())
        };
        return this._http.get<JobsiteSelectItem[]>(this.GET_MODELS_BY_MAKE_FAMILY, options).pipe(catchError(this.handleError));
    }

    public GetModelListByfamilyandMakeLifePerformance(makeId: number, familyId: number): Observable<Model[]> {
        let options = {
            params: new HttpParams().set('makeId', makeId.toString()).set('familyId', familyId.toString())
        };
        return this._http.get<Model[]>(this.GET_MODELS_BY_MAKE_FAMILY, options).pipe(catchError(this.handleError));
    }
    public getFamilyNameForModel(modelId: number): Observable<JobsiteSelectItem> {
        let options = {
            params: new HttpParams().set('modelId', modelId.toString())
        };
        return this._http.get<JobsiteSelectItem>(this.GET_FAMILY_NAME_FOR_MODEL, options).pipe(catchError(this.handleError));
    }

    public getEquipmentRankingList(): Observable<CustomerSelectItem[]> {
        return this._http.get<CustomerSelectItem[]>(this.GET_EQUIPMENT_RANKING_LIST).pipe(catchError(this.handleError));
    }

    public getEquipmentApplicationList(): Observable<ApplicationSelectedItem[]> {
        return this._http.get<ApplicationSelectedItem[]>(this.GET_APPLICATION_LIST).pipe(catchError(this.handleError));
    }

    public validateEquipmentSerialAndUnit(serialNumber: string, unitNumber: string, equipmentId: number): Observable<any> {
        let options;
        if (equipmentId > 0) {
            options = {
                params: new HttpParams().set('serialNumber', serialNumber).set('unitNumber', unitNumber).set('equipmentId', equipmentId.toString())
            };
        } else {
            options = {
                params: new HttpParams().set('serialNumber', serialNumber).set('unitNumber', unitNumber)
            };
        }
        return this._http.get(this.VALIDATE_SERIAL_UNIT_NUMBER, options).pipe(catchError(this.handleError));
    }



    public validateEquipmentSerialAndUnitDealerGroup(jobsite: number, customer: number, serialNumber: string, unitNumber: string, equipmentId: number): Observable<any> {
        let options;
        if (equipmentId > 0) {
            options = {
                params: new HttpParams().set('serialNumber', serialNumber).set('unitNumber', unitNumber).set('equipmentId', equipmentId.toString()).set('jobsite', jobsite.toString()).set('customer', customer.toString())
            };
        } else {
            options = {
                params: new HttpParams().set('serialNumber', serialNumber).set('unitNumber', unitNumber).set('jobsite', jobsite.toString()).set('customer', customer.toString())
            };
        }
        return this._http.get(this.VALIDATE_SERIAL_UNIT_NUMBER_DEALERGROUP, options).pipe(catchError(this.handleError));
    }

    public getUnsyncEquipmentInfo(unsyncedInspectionId: number): Observable<UnsyncedEquipmentInfoViewModel> {
        let options = {
            params: new HttpParams().set('unSyncedInspectionId', unsyncedInspectionId.toString())
        }
        return this._http.get<UnsyncedEquipmentInfoViewModel>(this.GET_UNSYNCED_EQUIPMENTINFO, options).pipe(catchError(this.handleError));
    }



    public getUserEmail(): Observable<any> {
        return this._http.get(this.GET_USEREMAIL).pipe(catchError(this.handleError));
    }



    public requestANewModelEmailSend(emailAddress: string, model: string, make: string): Observable<any> {
        const options = {
            params: new HttpParams().set('email', emailAddress).set('model', model).set('make', make)
        }
        return this._http.get<boolean>(this.SEND_NEW_MODEL_EMAIL, options).pipe(catchError(this.handleError));
    }

    public requestANewChainEmailSend(emailAddress: string, model: string, make: string, chainDesc: string): Observable<any> {
        const options = {
            params: new HttpParams().set('email', emailAddress).set('model', model).set('make', make).set('chaindescription', chainDesc)
        }
        return this._http.get(this.SEND_NEW_CHAIN_EMAIL, options).pipe(catchError(this.handleError));
    }
    public GetJobsiteTypes(): Observable<JobsiteTypeVM[]> {
        return this._http.get<JobsiteTypeVM[]>('api/ComponentLife/GetJobsityeTypesList').pipe(catchError(this.handleError));
    }

    public GetComponentTypes(): Observable<ComponentTypeVM[]> {
        return this._http.get<ComponentTypeVM[]>('api/ComponentLife/GetComponentTypesList').pipe(catchError(this.handleError));
    }

    public GetComponent(): Observable<ComponentTypeVM[]> {
        return this._http.get<ComponentTypeVM[]>('api/ComponentLife/GetComponentList').pipe(catchError(this.handleError));
    }

    //   public GetComponentPerformance(EquipmentID:number): Observable<ComponentPerformanceVM[]> {
    //       let options = {
    //           params:new HttpParams().set( 'EquipmentID', EquipmentID.toString())
    //       };
    //     return this._http.get('api/ComponentLife/GetComponentPerformanceList', options).pipe(catchError(this.handleError));
    //   }


    //new code
    //   public submitSelection(params: filterComponentPerformance): Observable<CmponentSearchResult> {
    //     return this._http.post('api/ComponentLife/GetComponentPerformanceList', params).share().map(
    //         (response: Response) => <CmponentSearchResult>response.json().catch(this.handleError);
    //   }
    //-----------------


    public submitSelection(params: filterComponentPerformance): Observable<CmponentSearchResult> {
        return this._http.post<CmponentSearchResult>('api/ComponentLife/GetComponentPerformanceList', params).pipe(catchError(this.handleError));
    }



    // public updateInspectionPlanner(equipment: Equipment): Observable<Tuple> {
    //     return this._http.post(this.UPDATE_INSPECTION_PLANNER, equipment).pipe(catchError(this.handleError));
    // }
    // public getEquipmentSetupDetails(equipmentId: number): Observable<Equipment> {
    //     let options = {
    //         params: new HttpParams().set('equipmentId', equipmentId.toString())
    //     };
    //     return this._http.get(this.GET_EQUIPMENT_SETUP_DETAILS, options).pipe(catchError(this.handleError));
    // }

    // public GetComponentActionHistory(ComponentId: number, EquipmentId: number): Observable<ComponentActionHistroyVM[]> {
    //     const options = {
    //       params: new HttpParams().set('ComponentId', ComponentId.toString()).set('EquipmentId', EquipmentId.toString())
    //     }
    //     return this._http.get<ComponentActionHistroyVM[]>('api/ComponentLife/GetComponetActionHistroyDetails', options).pipe(catchError(this.handleError));
    //   }


    public GetComponentActionHistory(ComponentId: number, EquipmentId: number): Observable<ComponentActionHistroyVM[]> {
        const options = {
            params: new HttpParams().set('ComponentId', ComponentId.toString()).set('EquipmentId', EquipmentId.toString())
        }
        return this._http.get<ComponentActionHistroyVM[]>('api/ComponentLife/GetComponetActionHistroyDetails', options).pipe(catchError(this.handleError));
    }

    public showDistTravelledTrackingForFamily(equipmentId: number, modelId: number): Observable<boolean> {
        let options = {
            params: new HttpParams().set('ModelId', modelId.toString()).set('EquipmentId', equipmentId.toString())
        };
        return this._http.get<boolean>('api/setupequipment/ShowDistTravelledTrackingForFamily', options).pipe(catchError(this.handleError));
    }

    //   public requestANewModelEmailSend(emailAddress: string, model: string, make:string): Observable<any> {
    //     const options = {
    //       params: new HttpParams().set('email', emailAddress).set('model', model).set('make', make)
    //     }
    //     return this._http.get(this.SEND_NEW_MODEL_EMAIL, options).pipe(catchError(this.handleError));
    //   }

    public GetUserEmail(): Observable<string> {
        return this._http.get<string>('api/User/GetUserEmail').pipe(catchError(this.handleError));
    }
    public GetComponentModel(compartId: number): Observable<JobsiteSelectItem[]> {
        let options = {
            params: new HttpParams().set('CompartId', compartId.toString())
        };
        return this._http.get<JobsiteSelectItem[]>('api/Components/GetComponentModel', options).pipe(catchError(this.handleError));
    }

    public getUcPlannerDetail(ucFleet: UcFleet): Observable<UcPlannerDetail[]> {
        return this._http.post<UcPlannerDetail[]>('api/UCPlanner/GetUcPlannerDetail', ucFleet).pipe(catchError(this.handleError));
    }

    public getUcPlannerFleetDetail(params: UcFleet): Observable<UcFleetEquipmentDetail[]> {

        return this._http.post<UcFleetEquipmentDetail[]>('api/UCPlanner/GetUcFleet', params).pipe(catchError(this.handleError));
    }

    public GetUcPlannerComponentDetail(customerId, selectedComponents): Observable<UCPlannerComponent[]> {
        let options = {
            params: new HttpParams().set('equipemntId', customerId.toString()).set('selectedComponents', selectedComponents)
        };
        return this._http.get<UCPlannerComponent[]>('api/UCPlanner/GetUcPlannerComponentDetail', options).pipe(catchError(this.handleError));
    }

    public GetUcPlannerLoadBudget(equipmentid: number): Observable<UCPlannerComponent[]> {
        let options = {
            params: new HttpParams().set('equipemntId', equipmentid.toString())
        };
        return this._http.get<UCPlannerComponent[]>('api/UCPlanner/GetUcPlannerComponentDetail', options).pipe(catchError(this.handleError));
    }


    public GetUcPlannerGraphDetail(customerId, selectedComponents): Observable<UcPlannerGrapVm> {
        let options = {
            params: new HttpParams().set('equipemntId', customerId.toString()).set('selectedComponents', selectedComponents)
        };
        return this._http.get<UcPlannerGrapVm>('api/UCPlanner/GetUcPlannerGraph', options).pipe(catchError(this.handleError));
    }

    public UcPlannerGraphHeadings(): Observable<UcPlannerGrapHeadingsVm> {

        return this._http.get<UcPlannerGrapHeadingsVm>('api/UCPlanner/UcPlannerGraphHeadings').pipe(catchError(this.handleError));
    }

    public GetActionRecommnnededStatus(): Observable<GenericIdName[]> {
        let options = {


        };
        return this._http.get<GenericIdName[]>('api/UCPlanner/GetActionRecommnnededStatus', options).pipe(catchError(this.handleError));
    }


    public getUcPlannerActionRecommendation(params: UcActionRecommedSearch): Observable<UcPlannerTrackQuoteDetailVm> {

        return this._http.post<UcPlannerTrackQuoteDetailVm>('api/UCPlanner/UcPlannerActionReconmmended', params).pipe(catchError(this.handleError));
    }

    public getUcPlannerActionStatusUpdate(_ActionQuoteCheck: ActionQuoteCheck): Observable<UcPlannerTrackQuoteDetailVm> {

        return this._http.post<UcPlannerTrackQuoteDetailVm>('api/UCPlanner/UcPlannerUpdateActionStatus', _ActionQuoteCheck).pipe(catchError(this.handleError));
    }

    public GetUcPlannerUserSettings(settingTypeid: number): Observable<UcPlannerDataVM> {

        let options = {
            params: new HttpParams().set('settingTypeId', settingTypeid.toString())
        };

        return this._http.get<UcPlannerDataVM>('api/UCPlanner/GetUcPlannerUserSettings', options).pipe(catchError(this.handleError));
    }

    public GetPlannerRecommendation(quoteAuto: number, date: string, componentId: number): Observable<QuoteDetailResultVm> {

        let options = {
            params: new HttpParams().set('quoteId', quoteAuto.toString(),).set('date', date.toString(),).set('equnitid', componentId.toString(),)
        };

        return this._http.get<QuoteDetailResultVm>('api/UCPlanner/GetRecommendation', options).pipe(catchError(this.handleError));
    }

    public GetUserPlannerDates(): Observable<DisplayOptionDate> {


        return this._http.get<DisplayOptionDate>('api/UCPlanner/GetDateDisplayOption').pipe(catchError(this.handleError));
    }

    public SavePlannerDates(SDate: string, enddate: string): Observable<number> {

        let options = {
            params: new HttpParams().set('Sdate', SDate.toString(),).set('Edate', enddate.toString())
        };

        return this._http.get<number>('api/UCPlanner/SaveDateDisplayOption', options).pipe(catchError(this.handleError));
    }

    public UcPlannerUserSettings(settingTypeid: number, Name: number, check: boolean): Observable<number> {

        let params = {
            SettingsTypeId: settingTypeid,
            ColumnId: Name,
            Check: check,

        }

        return this._http.post<number>('api/UCPlanner/UcPlannerUserSettings', params).pipe(catchError(this.handleError));
    }

    public getUcPlannerActionRecommendationEquipment(params: UcActionRecommedSearch): Observable<EquipmentQuoteSummaryVm> {

        return this._http.post<EquipmentQuoteSummaryVm>('api/UCPlanner/UcPlannerActionRecommnededByEquipment', params).pipe(catchError(this.handleError));
    }


    public UpdateTrackQuoteStatusDate(QuoteDetailId: number, date: string): Observable<UcPlannerStatusUpdate> {

        let updateData = {
            QuoteDetailId: QuoteDetailId,
            UpdateOn: date

        }

        return this._http.post<UcPlannerStatusUpdate>('api/UCPlanner/UpdateTrackQuoteStatusDate', updateData).pipe(catchError(this.handleError));
    }



    public GetPmServiceTypes(): Observable<PmServiceTypesVM> {


        return this._http.get<PmServiceTypesVM>('api/UCPlanner/GetPmServiceTypes').pipe(catchError(this.handleError));
    }


    public UcPlannerGraphHeadingsBudget(equipmentId: string): Observable<MonthlyQuoteSummaryVM> {

        let options = {
            params: new HttpParams().set('equipmentId', equipmentId.toString())
        };

        return this._http.get<MonthlyQuoteSummaryVM>('api/UCPlanner/UcPlannerGraphHeadingsBudget', options).pipe(catchError(this.handleError));
    }


    public PmDatesAdjust(inspectionId: number): Observable<ResponseM> {

        let updateData = {
            InspectionId: inspectionId,


        }


        return this._http.post<ResponseM>('api/UCPlanner/PmDatesAdjust', updateData).pipe(catchError(this.handleError));
    }

    public GetEquipmentInspectionCount(equipmentId: number): Observable<number> {

        let options = {
            params: new HttpParams().set('equipmentId', equipmentId.toString())
        };
        return this._http.get<number>('api/setupequipment/GetEquipmentInspectionCount', options).pipe(catchError(this.handleError));

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
